import { useEffect, useState } from 'react';

export const useCountdownTimer = (startSeconds: number, resetTrigger?: any) => {
    const [remainingSeconds, setRemainingSeconds] = useState(startSeconds);

    useEffect(() => {
        setRemainingSeconds(startSeconds); // reset when startSeconds, resetTrigger changes

        const interval = setInterval(() => {
            setRemainingSeconds((prev) => {
                if (prev <= 0) {
                    clearInterval(interval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval); // clean up on unmount or startSeconds change
    }, [startSeconds, resetTrigger]);

    const hours = Math.floor(remainingSeconds / 3600)
        .toString()
        .padStart(2, '0');
    const minutes = Math.floor((remainingSeconds % 3600) / 60)
        .toString()
        .padStart(2, '0');
    const seconds = (remainingSeconds % 60).toString().padStart(2, '0');

    return { hours, minutes, seconds, totalSeconds: remainingSeconds };
};
